import React from 'react';
import { FormEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../app/store';
import { authenticateUserFromStorage } from '../../../../app/features/sessions/sessionSlice';
import { useParams } from 'react-router-dom';
import { patchCurrentProject } from '../../../../app/features/sessions/projectsManagement/sessionManageProject';
import { toast } from 'react-toastify';
import { Box, IconButton, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const inputSx = {
    '& .MuiOutlinedInput-root': {
        color: '#f4f4f6',
        '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
        '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },

        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitBoxShadow: `0 0 0 100px #1c1c24 inset`,
            WebkitTextFillColor: '#f4f4f6',
            caretColor: '#f4f4f6',
        },
        '&.Mui-focused fieldset': { borderColor: 'rgba(255,255,255,0.7)' },
    },
    '& .MuiInputLabel-root': { color: 'rgba(244,244,246,0.65)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#f4f4f6', fontWeight: 700 },
};

export function FormCurrentProject({ handleEditTitleClicked }: any) {
    const currentUser   = useSelector((state: RootState) => state.session.currentUser);
    const authHeaders   = useSelector((state: RootState) => state.session.authHeaders);
    const userValidated = useSelector((state: RootState) => state.session.loggedIn);
    const dispatch      = useDispatch<AppDispatch>();
    const { userNicknameRoute, projectIdRoute } = useParams();
    const inputEditTitle = useRef<HTMLInputElement | null>(null);

    const [newTitle, setNewTitle] = useState<string>('');

    useEffect(() => {
        async function authenticateUser() {
            if (!userValidated) await dispatch(authenticateUserFromStorage());
        }
        authenticateUser();
    }, []);

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (!inputEditTitle.current) return;
        const response = await dispatch(patchCurrentProject({
            authHeaders,
            projectRouteParams: { userNicknameRoute, projectIdRoute },
            patchCurrentProjectBody: { title: inputEditTitle.current.value },
        }));
        if (response.payload.errors) {
            response.payload.errors.map((item: string) => toast.error(item));
        } else {
            handleEditTitleClicked();
        }
    }

    return (
        <Box component='form' onSubmit={handleSubmit} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
                inputRef={inputEditTitle}
                value={newTitle}
                onChange={(e) => setNewTitle(e.target.value)}
                size='small'
                placeholder='New title'
                autoFocus
                sx={inputSx}
            />
            <IconButton type='submit' size='small' sx={{ color: '#c0392b' }}>
                <CheckIcon fontSize='small' />
            </IconButton>
        </Box>
    );
}
